import { isPlainObject } from 'lodash';
import { getQuote } from '../selectors';

/**
 * @param {Object} state
 * @returns {Object}
 */
const getQuoteFinance = state => {
    const { finance } = getQuote(state);

    return isPlainObject(finance) ? finance : {};
};

/**
 * @param {Object} state
 * @returns {Object}
 */
const getTerm = state => {
    const { term } = getQuoteFinance(state);

    return isPlainObject(term) ? term : {};
};

/**
 * @param {Object} state
 * @returns {Object}
 */
const getAprDetails = state => {
    const { aprDetails } = getTerm(state);

    return isPlainObject(aprDetails) ? aprDetails : {};
};

export {
    getAprDetails
};
